import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

Vue.use(Vuex);

export default {
    namespaced: true,
    state: {
        imageFile: null,
        imagePreview: '',
        overlaySettings: {
            text: 'Hello [FirstName]!',
            fontSize: 24,
            style: 'white',
            shape: 'rectangle',
            brandColor: '#FF5722',
            position: { x: 50, y: 50 },
            rotation: 0,
            animation: {
                enabled: false,
                animationType: 'bounce',
                speed: 'medium'
            }
        },
        employeeId: null,
        recipientName: '',
        recipientEmail: '',
        isSending: false,
        isGifMode: false,
        shouldPreviewGif: false,
        editingImageId: null,
        savedImages: [],
        hasLoaded:false,
        cropModalOpen: false
    },

    mutations: {
        SET_IMAGE_FILE(state, file) {
            state.imageFile = file;
        },

        SET_IMAGE_PREVIEW(state, preview) {
            state.imagePreview = preview;
        },

        UPDATE_OVERLAY_TEXT(state, text) {
            state.overlaySettings.text = text;
        },

        UPDATE_CROP_MODAL_VISIBILITY(state, value) {
            state.cropModalOpen = value;
        },

        UPDATE_OVERLAY_FONT_SIZE(state, size) {
            state.overlaySettings.fontSize = size;
        },

        UPDATE_OVERLAY_STYLE(state, style) {
            state.overlaySettings.style = style;
        },

        UPDATE_OVERLAY_SHAPE(state, shape) {
            state.overlaySettings.shape = shape;
        },

        UPDATE_BRAND_COLOR(state, color) {
            state.overlaySettings.brandColor = color;
        },

        UPDATE_OVERLAY_POSITION(state, position) {
            state.overlaySettings.position = position;
        },

        UPDATE_EMPLOYEE_ID(state, employee) {
            state.employeeId = employee;
        },

        UPDATE_OVERLAY_ROTATION(state, rotation) {
            state.overlaySettings.rotation = rotation;
        },

        UPDATE_ANIMATION_ENABLED(state, enabled) {
            state.overlaySettings.animation.enabled = enabled;
        },

        UPDATE_ANIMATION_TYPE(state, type) {
            state.overlaySettings.animation.animationType = type;
        },

        UPDATE_ANIMATION_SPEED(state, speed) {
            state.overlaySettings.animation.speed = speed;
        },

        SET_RECIPIENT_NAME(state, name) {
            state.recipientName = name;
        },

        SET_RECIPIENT_EMAIL(state, email) {
            state.recipientEmail = email;
        },

        SET_IS_SENDING(state, isSending) {
            state.isSending = isSending;
        },

        SET_IS_GIF_MODE(state, isGifMode) {
            state.isGifMode = isGifMode;
        },

        SET_SHOULD_PREVIEW_GIF(state, shouldPreview) {
            state.shouldPreviewGif = shouldPreview;
        },

        SET_EDITING_IMAGE_ID(state, id) {
            state.editingImageId = id;
        },

        SET_SAVED_IMAGES(state, images) {
            state.savedImages = images;
        },
        SET_HAS_LOADED(state, val){
            state.hasLoaded = val;
        },

        RESET_EDITOR(state) {
            state.imageFile = null;
            state.imagePreview = '';
            state.overlaySettings = {
                text: 'Hello [FirstName]!',
                fontSize: 24,
                style: 'white',
                shape: 'rectangle',
                brandColor: '#FF5722',
                position: { x: 50, y: 50 },
                rotation: 0,
                animation: {
                    enabled: false,
                    animationType: 'bounce',
                    speed: 'medium'
                }
            };
            state.editingImageId = null;
            state.recipientName = '';
            state.recipientEmail = '';
            state.isGifMode = false;
            state.shouldPreviewGif = false;
            state.employeeId = null;
            state.cropModalOpen = false;
        }
    },

    actions: {
        async fetchSavedImages({ commit }, businessId) {
            try {
                const response = await axios.get(`/businesses/${businessId}/saved-images`);
                commit('SET_SAVED_IMAGES', response.data.data);
                commit('SET_HAS_LOADED', true);
            } catch (error) {
                commit('SET_HAS_LOADED', true);
                console.error('Error fetching saved images:', error);
                throw error;
            }
        },
        getImage({ commit }, { id, businessId }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/businesses/${businessId}/saved-image/${id}`)
                    .then((res) => {
                        const image = res.data.data;
                        // Set the image preview
                        commit('SET_IMAGE_PREVIEW', image.imageData);
                        if (image.employee_id) commit('UPDATE_EMPLOYEE_ID', image.employee_id);
                        // Parse and set overlay settings
                        if (image.settings) {
                            const settings = image.settings;
                            // Apply each setting
                            if (settings.text) commit('UPDATE_OVERLAY_TEXT', settings.text);
                            if (settings.fontSize) commit('UPDATE_OVERLAY_FONT_SIZE', settings.fontSize);
                            if (settings.style) commit('UPDATE_OVERLAY_STYLE', settings.style);
                            if (settings.shape) commit('UPDATE_OVERLAY_SHAPE', settings.shape);
                            if (settings.brandColor) commit('UPDATE_BRAND_COLOR', settings.brandColor);
                            if (settings.position) commit('UPDATE_OVERLAY_POSITION', settings.position);
                            if (settings.rotation !== undefined) commit('UPDATE_OVERLAY_ROTATION', settings.rotation);
                        }

                        // Set editing ID
                        commit('SET_EDITING_IMAGE_ID', image.id);
                        resolve(image)
                    })
                    .catch((error) => {
                        reject(error)
                    })
            })
        },
        getImageRendering({ commit }, { id, businessId }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/businesses/saved-image-rendering/${id}`)
                    .then((res) => {
                        const image = res.data.data;
                        // Set the image preview
                        commit('SET_IMAGE_PREVIEW', image.imageData);
                        if (image.employee_id) commit('UPDATE_EMPLOYEE_ID', image.employee_id);
                        // Parse and set overlay settings
                        if (image.settings) {
                            const settings = image.settings;
                            // Apply each setting
                            if (settings.text) commit('UPDATE_OVERLAY_TEXT', settings.text);
                            if (settings.fontSize) commit('UPDATE_OVERLAY_FONT_SIZE', settings.fontSize);
                            if (settings.style) commit('UPDATE_OVERLAY_STYLE', settings.style);
                            if (settings.shape) commit('UPDATE_OVERLAY_SHAPE', settings.shape);
                            if (settings.brandColor) commit('UPDATE_BRAND_COLOR', settings.brandColor);
                            if (settings.position) commit('UPDATE_OVERLAY_POSITION', settings.position);
                            if (settings.rotation !== undefined) commit('UPDATE_OVERLAY_ROTATION', settings.rotation);
                        }

                        // Set editing ID
                        commit('SET_EDITING_IMAGE_ID', image.id);
                        resolve(image)
                    })
                    .catch((error) => {
                        reject(error)
                    })
            })
        },
        saveImageName({ commit }, imageData) {
            return new Promise((resolve, reject) => {
                axios
                    .patch(`/businesses/${imageData.business_id}/saved-images/${imageData.image_id}/update-name`, imageData)
                    .then((res) => {
                        resolve(res.data.data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        saveImage({ commit }, imageData) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/businesses/${imageData.business_id}/save-image`, imageData)
                    .then((res) => {
                        resolve(res.data.data);
                    })
                    .catch((error) => {
                        console.error('Error loading saved image:', error);
                        reject(error);
                    });
            });
        },
        async deleteSavedImage({ dispatch }, {businessId, imageId}) {
            try {
                await axios.delete(`/businesses/${businessId}/saved-images/${imageId}`);
                // Refresh the list of saved images
                await dispatch('fetchSavedImages',businessId);
                return true;
            } catch (error) {
                console.error('Error deleting image:', error);
                throw error;
            }
        },
        async assignEmployee({dispatch}, image){
            try {
                await axios.post(`/businesses/${image.business_id}/saved-images/${image.id}/assign-employee`,image);
                // Refresh the list of saved images
                await dispatch('fetchSavedImages',image.business_id);
                Vue.$toast.open({
                    message: 'Employee was assigned',
                    type: 'success',
                    duration: 5000,
                })
                return true;
            } catch (error) {
                image.isWorking = false;
                console.error('Error setting default image:', error);
                throw error;
            }
        },
        async setDefaultSavedImage({ dispatch }, image) {
            try {
                image.defaultWorking = true;
                await axios.post(`/businesses/${image.business_id}/saved-images/${image.id}/set-default`);
                // Refresh the list of saved images
                await dispatch('fetchSavedImages',image.business_id);
                image.defaultWorking = false;
                return true;
            } catch (error) {
                image.defaultWorking = false;
                console.error('Error setting default image:', error);
                throw error;
            }
        },

        async loadSavedImage({ commit }, image) {
            try {
                // Set the image preview
                // commit('SET_IMAGE_PREVIEW', image.imageData);

                // Parse and set overlay settings
                if (image.settings) {
                    const settings = JSON.parse(image.settings);

                    // Apply each setting
                    if (settings.text) commit('UPDATE_OVERLAY_TEXT', settings.text);
                    if (settings.fontSize) commit('UPDATE_OVERLAY_FONT_SIZE', settings.fontSize);
                    if (settings.style) commit('UPDATE_OVERLAY_STYLE', settings.style);
                    if (settings.shape) commit('UPDATE_OVERLAY_SHAPE', settings.shape);
                    if (settings.brandColor) commit('UPDATE_BRAND_COLOR', settings.brandColor);
                    if (settings.position) commit('UPDATE_OVERLAY_POSITION', settings.position);
                    if (settings.rotation !== undefined) commit('UPDATE_OVERLAY_ROTATION', settings.rotation);
                }

                // Set editing ID
                commit('SET_EDITING_IMAGE_ID', image.id);

                return true;
            } catch (error) {
                console.error('Error loading saved image:', error);
                throw error;
            }
        }
    }
};
